import { MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";
import { IMG } from "../images";

const TILES = [
  { n: "01", t: "Property", d: "Selezione, setup e styling della villa a standard alberghiero." },
  { n: "02", t: "Arrival", d: "Check-in dedicato, welcome experience e presentazione della villa." },
  { n: "03", t: "Housekeeping", d: "Pulizia, biancheria e riassetto quotidiano livello hotellerie." },
  { n: "04", t: "Service", d: "Private chef, transfer ed esperienze attivabili su richiesta." },
  { n: "05", t: "Concierge", d: "Assistenza dedicata prima e durante l'intero soggiorno." },
  { n: "06", t: "Guest Experience", d: "Ogni soggiorno misurato, recensito e migliorato." },
];

export default function Slide03Standard() {
  return (
    <SlideShell theme="navy" testid="slide-3-standard">
      <SlideBody>
        <div className="grid items-center gap-12 lg:grid-cols-[1.3fr_1fr]">
          <div>
            <Reveal>
              <Micro>02 · Il Metodo</Micro>
            </Reveal>
            <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl">
              <MaskedLine delay={0.1}>
                VILLAFLOW <em className="italic text-[#D4AF37]">5-STAR</em>
              </MaskedLine>
              <MaskedLine delay={0.22}>STANDARD</MaskedLine>
            </h2>
            <div className="mt-10 grid gap-3 sm:grid-cols-2">
              {TILES.map((t, i) => (
                <Reveal key={t.n} delay={0.3 + i * 0.08}>
                  <div className="group h-full border border-[#D4AF37]/15 bg-[#0E1A36]/60 p-5 transition-all duration-500 hover:-translate-y-1 hover:border-[#D4AF37]/45">
                    <span className="font-mono text-[10px] tracking-[0.3em] text-[#D4AF37]/80">{t.n}</span>
                    <h3 className="mt-2 font-serif text-xl text-[#FAF7F2]">{t.t}</h3>
                    <p className="mt-2 text-[13px] leading-relaxed text-[#94A3B8]">{t.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
          <Reveal delay={0.5} className="hidden lg:block">
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-full w-full border border-[#D4AF37]/30" />
              <img
                src={IMG.standard}
                alt="Piscina di una villa luxury con vista mare"
                className="relative h-[440px] w-full object-cover xl:h-[500px]"
              />
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                Servizio a standard alberghiero, dentro la villa
              </p>
            </div>
          </Reveal>
        </div>
      </SlideBody>
    </SlideShell>
  );
}
